import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "text-center lead",
  style: {"font-size":"1.5rem"}
}
const _hoisted_2 = {
  key: 0,
  class: "card card-collapsable mt-1"
}
const _hoisted_3 = {
  id: "cardQuestion",
  class: "card-body collapse show pt-4"
}
const _hoisted_4 = { class: "PairwiseComparisonEditor" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }
const _hoisted_7 = { class: "mt1 ItemDetailsBox bg-color-blue3" }
const _hoisted_8 = { class: "btn-group ItemButton" }
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }
const _hoisted_11 = { class: "mt1 ItemDetailsBox bg-color-red3" }
const _hoisted_12 = { class: "btn-group ItemButton" }
const _hoisted_13 = { class: "dropdown-menu" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12" }
const _hoisted_18 = { style: {"margin-top":"30px"} }
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 1,
  class: "PairwiseComparisonEditor"
}
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }
const _hoisted_23 = { class: "mt1 ItemDetailsBox bg-color-blue3" }
const _hoisted_24 = { class: "btn-group ItemButton" }
const _hoisted_25 = { class: "dropdown-menu" }
const _hoisted_26 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }
const _hoisted_27 = { class: "mt1 ItemDetailsBox bg-color-red3" }
const _hoisted_28 = { class: "btn-group ItemButton" }
const _hoisted_29 = { class: "dropdown-menu" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12" }
const _hoisted_34 = {
  key: 0,
  class: "text-center"
}
const _hoisted_35 = { style: {"margin-top":"30px"} }
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  key: 2,
  class: "PairwiseComparisonVotesBrowserView mt-4",
  style: {"min-height":"500px"}
}
const _hoisted_38 = { class: "nav nav-tabs" }
const _hoisted_39 = { class: "nav-item" }
const _hoisted_40 = { class: "nav-item" }
const _hoisted_41 = { class: "nav-item" }
const _hoisted_42 = { class: "tab-content" }
const _hoisted_43 = { class: "table-responsive" }
const _hoisted_44 = { class: "table table-striped" }
const _hoisted_45 = {
  class: "clearfix",
  style: {"min-width":"510px","border-top":"0"}
}
const _hoisted_46 = {
  class: "clearfix pull-right",
  style: {"width":"85%"}
}
const _hoisted_47 = { class: "pull-left" }
const _hoisted_48 = { class: "pull-right" }
const _hoisted_49 = { style: {"text-align":"center"} }
const _hoisted_50 = { style: {"text-align":"left"} }
const _hoisted_51 = { style: {"padding":"0"} }
const _hoisted_52 = {
  class: "clearfix",
  style: {"list-style":"none","margin":"0","padding":"0"}
}
const _hoisted_53 = { style: {"text-align":"center"} }
const _hoisted_54 = { style: {"text-align":"left"} }
const _hoisted_55 = { style: {"padding":"0"} }
const _hoisted_56 = {
  class: "clearfix",
  style: {"list-style":"none","margin":"0","padding":"0"}
}
const _hoisted_57 = { class: "table-responsive" }
const _hoisted_58 = { class: "table" }
const _hoisted_59 = {
  style: {"text-align":"center"},
  class: "bottom noborder"
}
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = { style: {"text-align":"center"} }
const _hoisted_62 = ["colspan"]
const _hoisted_63 = ["colspan"]
const _hoisted_64 = { class: "blockquote" }
const _hoisted_65 = { class: "mb-0" }
const _hoisted_66 = { class: "blockquote-footer" }

import { ref, computed } from 'vue'
    import { boolCompare, isNullOrWhitespace, numCompare } from '@common/Common'

    import type { ScoringVoteEntry } from '@Evaluation/AlternativesSurveys/Domain/readmodels'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingQuestionReviewPc',
  props: {
    propIsMeetingManager: { type: Boolean },
    propContextName: {},
    propFirstAlternativeName: {},
    propSecondAlternativeName: {},
    propVotesEntries: {},
    propValue: {},
    propComment: {}
  },
  emits: ["update-vote-value", "update-vote-comment", "show-first-alternative-details", "show-second-alternative-details", "show-criterion-details"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- local state ---------------- */

    const ActiveTab = ref<'votes' | 'summary' | 'notes'>('votes')

    const ScaleView1 = [
        9, 8, 7, 6, 5, 4, 3, 2, 1,
        1 / 2, 1 / 3, 1 / 4, 1 / 5, 1 / 6, 1 / 7, 1 / 8, 1 / 9
    ].sort((a, b) => numCompare(a, b))

    /* ---------------- shortcuts ---------------- */

    const isMeetingManager = computed(() => props.propIsMeetingManager)
    const contextName = computed(() => props.propContextName)
    const firstAlternativeName = computed(() => props.propFirstAlternativeName)
    const secondAlternativeName = computed(() => props.propSecondAlternativeName)

    const votesEntries = computed(() => props.propVotesEntries)
    const value = computed<number | null>(() => props.propValue ?? null)
    const comment = computed<string | null>(() => props.propComment ?? null)

    /* ---------------- derived ---------------- */

    const VotesEntriesView = computed(() => votesEntries.value)

    const Comments = computed(() =>
        votesEntries.value.filter(e => !isNullOrWhitespace(e.Comment))
    )

    const VotesTabActive = computed(() => ActiveTab.value === 'votes')
    const SummaryTabActive = computed(() => ActiveTab.value === 'summary')
    const CommentsTabActive = computed(() => ActiveTab.value === 'notes')

    const EqualitySelected = computed(() => value.value === 1.0)
    const FirstSelected = computed(() => value.value != null && value.value > 1.0)
    const SecondSelected = computed(() => value.value != null && value.value < 1.0)

    /* ---------------- averages ---------------- */

    const Average = computed<number | null>(() =>
    {
        const valid = votesEntries.value.filter(e => e.Value != null && e.VoteStrength > 0)
        if (!valid.length) return null

        const sumWeights = valid.reduce((s, e) => s + e.VoteStrength, 0)

        let avg = 1.0
        for (const e of valid)
        {
            avg *= Math.pow(e.Value, e.VoteStrength / sumWeights)
        }

        return avg
    })

    const AverageDescription = computed(() =>
    {
        if (Average.value == null) return 'N/A'
        return Average.value < 1
            ? (1 / Average.value).toFixedIfNeeded(2)
            : Average.value.toFixedIfNeeded(2)
    })

    /* ---------------- scale ---------------- */

    const ScaleView = computed<number[]>(() =>
    {
        const base = [...ScaleView1]
        if (Average.value != null)
        {
            if (!base.some(v => Math.round(v * 100) === Math.round(Average.value * 100)))
            {
                base.push(Average.value)
            }
        }
        return base.sort((a, b) => numCompare(a, b)).reverse()
    })

    const LeftScaleValuesCount = computed(() => ScaleView.value.filter(v => v > 1).length)
    const RightScaleValuesCount = computed(() => ScaleView.value.filter(v => v < 1).length)

    const IntegerValue = computed<number | null>(() =>
    {
        if (!value.value) return null
        return Math.round((value.value < 1 ? 1 / value.value : value.value) * 100) / 100
    })

    /* ---------------- labels ---------------- */

    function GetLabel(v: number): string
    {
        switch (v)
        {
            case 2: return 'Weakly'
            case 3: return 'Moderately'
            case 4: return 'Moderately +'
            case 5: return 'Strongly'
            case 6: return 'Strongly +'
            case 7: return 'Very Strongly'
            case 8: return 'Very Strongly +'
            case 9: return 'Extremely'
            default: return ''
        }
    }

    const FirstBtnLabel = computed(() =>
        FirstSelected.value
            ? `${GetLabel(IntegerValue.value)} (${IntegerValue.value})`
            : 'More preferred'
    )

    const SecondBtnLabel = computed(() =>
        SecondSelected.value
            ? `${GetLabel(IntegerValue.value)} (${IntegerValue.value})`
            : 'More preferred'
    )

    /* ---------------- histogram ---------------- */

    const HistogramValues = computed(() =>
    {
        const voteValues = votesEntries.value.filter(e => e.Value != null).map(e => e.Value)
        const uniqueValues = new Set([...ScaleView1, ...voteValues])
        const orderedValues = [...uniqueValues].sort((a, b) => b - a)

        let maxCount = 0
        for (const v of orderedValues)
        {
            maxCount = Math.max(maxCount, voteValues.filter(x => x === v).length)
        }

        return orderedValues.map(v =>
        {
            const count = voteValues.filter(x => x === v).length
            return {
                Value: v,
                Count: count,
                PercentOfMax: maxCount ? Math.round((count / maxCount) * 100) : 0
            }
        })
    })

    /* ---------------- scale rendering helpers ---------------- */

    function FormatValue(v: number): number
    {
        return v < 1 ? 1 / v : v
    }

    function GetColor(v: number): string
    {
        const r = Math.round(v * 100) / 100
        if (r === 1) return 'bg-color-green2'
        if (r > 1) return 'bg-color-blue2'
        return 'bg-color-red2'
    }

    function GetScaleItemType(scaleValue: number, voteValue: number | null): string | null
    {
        if (voteValue == null) return 'Empty'
        if (scaleValue < 1 && voteValue > 1) return 'Empty'
        if (scaleValue > 1 && voteValue < 1) return 'Empty'

        let x: number | null = null

        if (scaleValue <= 1 && voteValue <= 1) x = (1 / scaleValue) - (1 / voteValue)
        if (scaleValue >= 1 && voteValue >= 1) x = scaleValue - voteValue

        x = Math.round(x * 100) / 100

        if (x === 0) return 'Filled'
        if (x >= 1 || x <= -1) return 'Empty'
        if (x > -1 && x < 0) return 'Hidden'
        if (x > 0 && x < 1) return 'DoubleFilled'

        return null
    }

    function GetCssClass(scaleValue: number, voteValue: number | null): string | null
    {
        const type = GetScaleItemType(scaleValue, voteValue)
        if (type === 'Empty') return 'EmptyScaleItem'
        if (type === 'Hidden') return 'HiddenScaleItem'
        if (type === 'Filled') return `FilledScaleItem ${GetColor(voteValue)}`
        if (type === 'DoubleFilled') return `DoubleFilledScaleItem ${GetColor(voteValue)}`
        return null
    }

    function GetScaleItemText(scaleValue: number, voteValue: number | null): string
    {
        const type = GetScaleItemType(scaleValue, voteValue)
        return type === 'DoubleFilled'
            ? FormatValue(voteValue).toFixedIfNeeded(2)
            : FormatValue(scaleValue).toLocaleString()
    }

    /* ---------------- actions ---------------- */

    function updateValue(v: number | null)
    {
        emit('update-vote-value', v)
    }

    function updateComment(c: string)
    {
        emit('update-vote-comment', c)
    }

    function showFirstAlternativeDetails()
    {
        emit('show-first-alternative-details')
    }

    function showSecondAlternativeDetails()
    {
        emit('show-second-alternative-details')
    }

    function showCriterionDetails()
    {
        emit('show-criterion-details')
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, [
      _cache[41] || (_cache[41] = _createTextVNode(" In the context of ", -1 /* CACHED */)),
      _createElementVNode("a", {
        class: "text-primary",
        onClick: showCriterionDetails,
        title: "Show details"
      }, _toDisplayString(contextName.value), 1 /* TEXT */),
      _cache[42] || (_cache[42] = _createTextVNode(", which alternative do you prefer: ", -1 /* CACHED */)),
      _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createElementVNode("a", {
        class: "text-primary",
        onClick: showFirstAlternativeDetails,
        title: "Show details"
      }, _toDisplayString(firstAlternativeName.value), 1 /* TEXT */),
      _cache[44] || (_cache[44] = _createTextVNode(" or ", -1 /* CACHED */)),
      _createElementVNode("a", {
        class: "text-primary",
        onClick: showSecondAlternativeDetails,
        title: "Show details"
      }, _toDisplayString(secondAlternativeName.value), 1 /* TEXT */),
      _cache[45] || (_cache[45] = _createTextVNode("? ", -1 /* CACHED */))
    ]),
    (isMeetingManager.value === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[53] || (_cache[53] = _createElementVNode("div", {
            class: "card-header pointer",
            "data-toggle": "collapse",
            href: "#cardQuestion"
          }, " Group vote ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h4", null, _toDisplayString(firstAlternativeName.value), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-block dropdown-toggle", FirstSelected.value === true ? 'btn-success' : 'btn-outline-secondary']),
                      "data-toggle": "dropdown"
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa-regular", FirstSelected.value === true ? 'fa-square-check' : 'fa-square']),
                        "aria-hidden": "true"
                      }, null, 2 /* CLASS */),
                      _createTextVNode(" " + _toDisplayString(FirstBtnLabel.value), 1 /* TEXT */)
                    ], 2 /* CLASS */),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[46] || (_cache[46] = _createElementVNode("h4", { class: "dropdown-header" }, "How strong is your preference?", -1 /* CACHED */)),
                      _cache[47] || (_cache[47] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (updateValue(2)))
                      }, "Weak (2)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (updateValue(3)))
                      }, "Moderate (3)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (updateValue(4)))
                      }, "Moderate + (4)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (updateValue(5)))
                      }, "Strong (5)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (updateValue(6)))
                      }, "Strong + (6)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (updateValue(7)))
                      }, "Very strong (7)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (updateValue(8)))
                      }, "Very strong + (8)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (updateValue(9)))
                      }, "Extreme (9)")
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h4", null, _toDisplayString(secondAlternativeName.value), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-block dropdown-toggle", SecondSelected.value === true ? 'btn-success' : 'btn-outline-secondary']),
                      "data-toggle": "dropdown"
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa-regular", SecondSelected.value === true ? 'fa-square-check' : 'fa-square']),
                        "aria-hidden": "true"
                      }, null, 2 /* CLASS */),
                      _createTextVNode(" " + _toDisplayString(SecondBtnLabel.value), 1 /* TEXT */)
                    ], 2 /* CLASS */),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[48] || (_cache[48] = _createElementVNode("h4", { class: "dropdown-header" }, "How strong is your preference?", -1 /* CACHED */)),
                      _cache[49] || (_cache[49] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (updateValue(1.0/2.0)))
                      }, "Weak (2)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (updateValue(1.0/3.0)))
                      }, "Moderate (3)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (updateValue(1.0/4.0)))
                      }, "Moderate + (4)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (updateValue(1.0/5.0)))
                      }, "Strong (5)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (updateValue(1.0/6.0)))
                      }, "Strong + (6)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (updateValue(1.0/7.0)))
                      }, "Very strong (7)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (updateValue(1.0/8.0)))
                      }, "Very strong + (8)"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (updateValue(1.0/9.0)))
                      }, "Extreme (9)")
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-block btn-equal mt1", EqualitySelected.value === true ? 'btn-success' : 'btn-outline-secondary']),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (updateValue(1.0)))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-regular", EqualitySelected.value === true ? 'fa-square-check' : 'fa-square']),
                      "aria-hidden": "true"
                    }, null, 2 /* CLASS */),
                    _cache[50] || (_cache[50] = _createElementVNode("span", null, "Equally preferred (1)", -1 /* CACHED */))
                  ], 2 /* CLASS */)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-block mt1", value.value == null ? 'btn-success' : 'btn-outline-secondary']),
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (updateValue(null)))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-regular", value.value == null ? 'fa-square-check' : 'fa-square']),
                      "aria-hidden": "true"
                    }, null, 2 /* CLASS */),
                    _cache[51] || (_cache[51] = _createTextVNode(" Follow the average (default) ", -1 /* CACHED */))
                  ], 2 /* CLASS */)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[52] || (_cache[52] = _createElementVNode("h5", { style: {"margin-bottom":"5px"} }, "Comment:", -1 /* CACHED */)),
                _createElementVNode("textarea", {
                  rows: "5",
                  value: comment.value,
                  onInput: _cache[18] || (_cache[18] = ($event: any) => (updateComment($event.target.value))),
                  class: "form-control",
                  placeholder: "Comment..."
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_19)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (isMeetingManager.value === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h4", null, _toDisplayString(firstAlternativeName.value), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-block dropdown-toggle", FirstSelected.value === true ? 'btn-success' : 'btn-outline-secondary']),
                  "data-toggle": "dropdown"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fa-regular", FirstSelected.value === true ? 'fa-square-check' : 'fa-square']),
                    "aria-hidden": "true"
                  }, null, 2 /* CLASS */),
                  _createTextVNode(" " + _toDisplayString(FirstBtnLabel.value), 1 /* TEXT */)
                ], 2 /* CLASS */),
                _createElementVNode("div", _hoisted_25, [
                  _cache[54] || (_cache[54] = _createElementVNode("h4", { class: "dropdown-header" }, "How strong is your preference?", -1 /* CACHED */)),
                  _cache[55] || (_cache[55] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (updateValue(2)))
                  }, "Weak (2)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (updateValue(3)))
                  }, "Moderate (3)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (updateValue(4)))
                  }, "Moderate + (4)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (updateValue(5)))
                  }, "Strong (5)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (updateValue(6)))
                  }, "Strong + (6)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (updateValue(7)))
                  }, "Very strong (7)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (updateValue(8)))
                  }, "Very strong + (8)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (updateValue(9)))
                  }, "Extreme (9)")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h4", null, _toDisplayString(secondAlternativeName.value), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-block dropdown-toggle", SecondSelected.value === true ? 'btn-success' : 'btn-outline-secondary']),
                  "data-toggle": "dropdown"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fa-regular", SecondSelected.value === true ? 'fa-square-check' : 'fa-square']),
                    "aria-hidden": "true"
                  }, null, 2 /* CLASS */),
                  _createTextVNode(" " + _toDisplayString(SecondBtnLabel.value), 1 /* TEXT */)
                ], 2 /* CLASS */),
                _createElementVNode("div", _hoisted_29, [
                  _cache[56] || (_cache[56] = _createElementVNode("h4", { class: "dropdown-header" }, "How strong is your preference?", -1 /* CACHED */)),
                  _cache[57] || (_cache[57] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (updateValue(1.0/2.0)))
                  }, "Weak (2)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (updateValue(1.0/3.0)))
                  }, "Moderate (3)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (updateValue(1.0/4.0)))
                  }, "Moderate + (4)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (updateValue(1.0/5.0)))
                  }, "Strong (5)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[31] || (_cache[31] = ($event: any) => (updateValue(1.0/6.0)))
                  }, "Strong + (6)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (updateValue(1.0/7.0)))
                  }, "Very strong (7)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[33] || (_cache[33] = ($event: any) => (updateValue(1.0/8.0)))
                  }, "Very strong + (8)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[34] || (_cache[34] = ($event: any) => (updateValue(1.0/9.0)))
                  }, "Extreme (9)")
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-block btn-equal mt1", EqualitySelected.value === true ? 'btn-success' : 'btn-outline-secondary']),
                onClick: _cache[35] || (_cache[35] = ($event: any) => (updateValue(1.0)))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-regular", EqualitySelected.value === true ? 'fa-square-check' : 'fa-square']),
                  "aria-hidden": "true"
                }, null, 2 /* CLASS */),
                _cache[58] || (_cache[58] = _createElementVNode("span", null, "Equally preferred (1)", -1 /* CACHED */))
              ], 2 /* CLASS */)
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              (value.value != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-link mt1",
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (updateValue(null)))
                    }, [...(_cache[59] || (_cache[59] = [
                      _createElementVNode("i", {
                        class: "fa fa-times",
                        "aria-hidden": "true"
                      }, null, -1 /* CACHED */),
                      _createTextVNode(" Clear answer ", -1 /* CACHED */)
                    ]))])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[60] || (_cache[60] = _createElementVNode("h5", { style: {"margin-bottom":"5px"} }, "Comment:", -1 /* CACHED */)),
            _createElementVNode("textarea", {
              rows: "5",
              value: comment.value,
              onInput: _cache[37] || (_cache[37] = ($event: any) => (updateComment($event.target.value))),
              class: "form-control",
              placeholder: "Comment..."
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_36)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (isMeetingManager.value === true || votesEntries.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("ul", _hoisted_38, [
            _createElementVNode("li", _hoisted_39, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active': VotesTabActive.value }]),
                onClick: _cache[38] || (_cache[38] = ($event: any) => (ActiveTab.value = 'votes'))
              }, "Votes", 2 /* CLASS */)
            ]),
            _createElementVNode("li", _hoisted_40, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active': SummaryTabActive.value }]),
                onClick: _cache[39] || (_cache[39] = ($event: any) => (ActiveTab.value = 'summary'))
              }, "Chart", 2 /* CLASS */)
            ]),
            _createElementVNode("li", _hoisted_41, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active': CommentsTabActive.value }]),
                onClick: _cache[40] || (_cache[40] = ($event: any) => (ActiveTab.value = 'notes'))
              }, "Comments", 2 /* CLASS */)
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            (VotesTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([{'active': VotesTabActive.value}, "tab-pane pt-2"])
                }, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("table", _hoisted_44, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[62] || (_cache[62] = _createElementVNode("th", { style: {"border-top":"0"} }, null, -1 /* CACHED */)),
                          _createElementVNode("th", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, _toDisplayString(firstAlternativeName.value), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_48, _toDisplayString(secondAlternativeName.value), 1 /* TEXT */),
                              _cache[61] || (_cache[61] = _createElementVNode("div", {
                                class: "text-center",
                                style: {"margin":"0 auto","width":"50px"}
                              }, " vs ", -1 /* CACHED */))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_49, [
                          _createElementVNode("td", _hoisted_50, [
                            _createElementVNode("strong", null, "Average (" + _toDisplayString(AverageDescription.value) + ")", 1 /* TEXT */)
                          ]),
                          _createElementVNode("td", _hoisted_51, [
                            _createElementVNode("ul", _hoisted_52, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ScaleView1), (scaleValue) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: _normalizeClass(GetCssClass(scaleValue, Average.value))
                                }, _toDisplayString(GetScaleItemText(scaleValue, Average.value)), 3 /* TEXT, CLASS */))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(VotesEntriesView.value, (e) => {
                          return (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                            _createElementVNode("td", _hoisted_54, _toDisplayString(e.VotesSourceName ?? '???'), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_55, [
                              _createElementVNode("ul", _hoisted_56, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ScaleView1), (scaleValue) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: _normalizeClass(GetCssClass(scaleValue, e.Value))
                                  }, _toDisplayString(GetScaleItemText(scaleValue, e.Value)), 3 /* TEXT, CLASS */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])
                            ])
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ])
                  ])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            (SummaryTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([{ 'active': SummaryTabActive.value }, "tab-pane pt-2"])
                }, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("table", _hoisted_58, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_59, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(HistogramValues.value, (v) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: v.Value,
                              style: {"height":"400px","border":"none","padding-top":"20px"}
                            }, [
                              (v.Count)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    innerHTML: v.Count
                                  }, null, 8 /* PROPS */, _hoisted_60))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", {
                                style: _normalizeStyle({'height': v.PercentOfMax + '%'}),
                                class: _normalizeClass([GetColor(v.Value), "bg-color-blue2"])
                              }, null, 6 /* CLASS, STYLE */)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _createElementVNode("tr", _hoisted_61, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(HistogramValues.value, (v) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: v.Value,
                              style: {"width":"6%"}
                            }, _toDisplayString(FormatValue(v.Value).toFixedIfNeeded(2)), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]),
                      _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", {
                            colspan: LeftScaleValuesCount.value,
                            style: {"text-align":"left"}
                          }, _toDisplayString(firstAlternativeName.value), 9 /* TEXT, PROPS */, _hoisted_62),
                          _cache[63] || (_cache[63] = _createElementVNode("th", { style: {"text-align":"center"} }, "vs", -1 /* CACHED */)),
                          _createElementVNode("th", {
                            colspan: RightScaleValuesCount.value,
                            style: {"text-align":"right"}
                          }, _toDisplayString(secondAlternativeName.value), 9 /* TEXT, PROPS */, _hoisted_63)
                        ])
                      ])
                    ])
                  ])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            (CommentsTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass([{ 'active': CommentsTabActive.value }, "tab-pane pt-2"])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Comments.value, (c) => {
                    return (_openBlock(), _createElementBlock("blockquote", _hoisted_64, [
                      _createElementVNode("p", _hoisted_65, _toDisplayString(c.Comment), 1 /* TEXT */),
                      _createElementVNode("footer", _hoisted_66, _toDisplayString(c.VotesSourceName ?? '???'), 1 /* TEXT */)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})